import { NgClass } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { HeaderBreadcrumbsComponent } from '@uigy/core/modules/layout/header/em-breadcrumbs/header-breadcrumbs.component';
import { CopyrightComponent } from '@uigy/shared/components/copyright/copyright.component';
import { FlyoutComponent } from '@uigy/shared/flyout/flyout/flyout.component';
import { FlyoutSettings } from '@uigy/shared/models/interfaces';
import { Language } from '@uigy/shared/models/language';
import { AuthService } from '@uigy/shared/services/auth.service';
import { LanguageService } from '@uigy/shared/services/language.service';
import { IemService } from '@uigy/shared/services/iem.service';
import { UIButtonComponent } from '@uigy/shared/components/ui-button/ui-button.component';
import { IcpEmTagComponent } from '@uigy/shared/tag/icp-em-tag/icp-em-tag.component';

@Component({
  selector: 'app-mini-layout-wrapper',
  templateUrl: './mini-layout-wrapper.component.html',
  styleUrls: ['./mini-layout-wrapper.component.scss'],
  imports: [
    FlyoutComponent,
    UIButtonComponent,
    HeaderBreadcrumbsComponent,
    IcpEmTagComponent,
    NgClass,
    CopyrightComponent
],
})
export class MiniLayoutWrapperComponent implements OnInit {
  private authService = inject(AuthService);
  private languageService = inject(LanguageService);
  iemService = inject(IemService);

  @Input() showLogout = false;
  @Input() showLanguages = false;
  @Input() logoPosition: 'center' | 'left' = 'center';

  private readonly LANGUAGES = this.languageService.languages ?? [];
  public logoutText = this.languageService.texts.about.buttons.logout;

  public languageFlyout: FlyoutSettings<Language> = {
    labelKey: 'value',
    valueKey: 'key',
    items: this.LANGUAGES,
    btnClass: 'g-ghost-btn__white',
    selected: this.languageService.language,
  };

  public ngOnInit(): void {
    this.logoutText = this.iemService.isIcpViewInEm() ? this.languageService.texts.icps.return_to_em : this.languageService.texts.about.buttons.logout;
  }

  public rightActionsClick(): void {
    this.iemService.isIcpViewInEm() ? this.redirectToEm() : this.logout();
  }

  public logout(): void {
    this.authService.logout();
  }

  public redirectToEm(): void {
    window.location.href = window.location.origin;
  }

  public changeLanguage(language: Language): void {
    this.languageService.changeLanguage(language);
  }
}
